module.exports = __webpack_public_path__ + "img/35475749000170.279a4acb.png";